import { type AriaButtonProps, useButton } from "@react-aria/button";
import React, { useRef } from "react";

const AccessibleButton = React.forwardRef<
  HTMLButtonElement,
  React.HTMLProps<HTMLButtonElement> & AriaButtonProps<"button">
>((props, ref) => {
  if (typeof ref !== "object") {
    throw new Error("This component may only be used with an object ref");
  }
  const fallbackRef = useRef<HTMLButtonElement>(null);
  const domRef = ref ?? fallbackRef;

  const { buttonProps } = useButton(props, domRef);
  return (
    <button
      {...buttonProps}
      ref={domRef}
      className={props.className}
      onKeyDown={(e) => e.stopPropagation()}
    >
      {props.children}
    </button>
  );
});

export default AccessibleButton;
